import { createModalStore } from '@/shared/lib/modal';

export const useEnterprisePaymentRequiredModalStore = createModalStore();
